import * as React from 'react';
import { DigitalAsset, SocialMediaAsset } from '../../models/SocialMediaAsset/SocialMediaAsset';
import { observer } from 'mobx-react';
import StyleTag from '../StyleTag/StyleTag';
import { Card } from 'components/spaceKit';
import ImageAssetIcon from '@sprinklr/spaceweb-icons/solid/ImageAsset';
import VideoAssetIcon from '@sprinklr/spaceweb-icons/solid/VideoAsset';
import lighten from 'polished/lib/color/lighten';
import styled, { css } from 'components/_UI/designSystem';

const StyledPreviewBackground = styled.div<{ isTransparent: boolean }>`
    ${({ theme, isTransparent }) => {
        if (isTransparent) {
            const gridColor = lighten(0.05, theme.card.default.background);
            return css`
                background-image: linear-gradient(45deg, ${gridColor} 25%, transparent 25%),
                    linear-gradient(-45deg, ${gridColor} 25%, transparent 25%),
                    linear-gradient(45deg, transparent 75%, ${gridColor} 75%),
                    linear-gradient(-45deg, transparent 75%, ${gridColor} 75%);

                background-size: 10px 10px;
                width: 100%;
                height: 100%;
            `;
        }
    }}
`;

interface SAMPreviewProps {
    asset?: SocialMediaAsset;
    sampleText?: string;
    onAssetClicked?(id: string): void;
}

class SAMPreview extends React.Component<SAMPreviewProps, any> {
    public static readonly defaultProps: SAMPreviewProps = {
        sampleText: 'The lorem fox jumps over the ipsum text',
    };

    constructor(props: SAMPreviewProps, ctx: any) {
        super(props, ctx);
    }

    render() {
        const { asset } = this.props;

        const sda: DigitalAsset = asset ? asset.secureDigitalAsset : null;
        const nda: DigitalAsset = asset ? asset.digitalAsset : null;
        const digitalAsset: DigitalAsset = sda ? sda : nda;

        let style = null;
        let textSample = null;
        let dimensions;

        if (digitalAsset) {
            if (digitalAsset.imageHeight && digitalAsset.imageWidth) {
                dimensions = `${digitalAsset.imageHeight}${digitalAsset.imageHeightUnit} x ${digitalAsset.imageWidth}${digitalAsset.imageWidthUnit}`;
            }

            if (asset.assetType === 'FONT') {
                // TODO: add fallbacks for non-enhanced fonts? should be handled by SocialMediaAssetService probably...
                const fontFamily =
                    asset.digitalAsset && asset.digitalAsset.font && asset.digitalAsset.font.family;

                const cssText = `
                   @font-face {
                      font-family: '${fontFamily}';
                      src: url('${digitalAsset && digitalAsset.mediaUrl}');
                   }
                `;
                style = <StyleTag css={cssText} />;
                textSample = <span style={{ fontFamily }}>{this.props.sampleText}</span>;
            }
        } else {
            console.warn('Have no digital asset, props: ', this.props);
        }

        const previewUrl =
            nda?.mediaMimeType === 'image/gif' ? digitalAsset?.mediaUrl : digitalAsset?.previewUrl;

        const isTransparent =
            nda?.mediaMimeType === 'image/png' || nda.mediaMimeType === 'image/gif';

        let missingAssetIcon = null;
        if (digitalAsset && !previewUrl) {
            if (asset.assetType === 'IMAGE') {
                missingAssetIcon = (
                    <ImageAssetIcon
                        size={40}
                        className={'spr-icon-03'}
                        style={{ margin: 'auto' }}
                    />
                );
            }
            if (asset.assetType === 'VIDEO') {
                missingAssetIcon = (
                    <VideoAssetIcon
                        size={40}
                        className={'spr-icon-03'}
                        style={{ margin: 'auto' }}
                    />
                );
            }
        }

        return (
            <Card
                title={asset.name && asset.name}
                subTitle={dimensions && dimensions}
                titleClamp={2}
                onContentClick={() => this.props.onAssetClicked(asset.id)}>
                {style}

                {digitalAsset && previewUrl && (
                    <StyledPreviewBackground isTransparent={isTransparent}>
                        <div
                            style={{
                                backgroundImage: `url('${previewUrl}')`,
                                width: '100%',
                                height: '100%',
                            }}
                            className='fullbleed bg-default bg-contain'
                        />
                    </StyledPreviewBackground>
                )}

                {missingAssetIcon}

                {textSample}
            </Card>
        );
    }
}

export default observer(SAMPreview);
